let globalRefetch: (() => void) | null = null;

/** Called from {@link MaterialRequestPendingCountProvider} only. */
export function setPendingMaterialRequestCountRefetch(
  fn: (() => void) | null,
): void {
  globalRefetch = fn;
}

/**
 * Refetch pending material request count (sidebar badge). Used after approve,
 * reject, cancel, or submit without importing React context from feature modules.
 */
export function invalidatePendingMaterialRequestCount(): void {
  globalRefetch?.();
}
